import { Link } from "react-router-dom";

import { Comment } from "../../components/comment/Comment";
import { CommentBody } from "../../components/comment/CommentBody";
import { GardenerStoppedWorkingForCustomerCommentDocument } from "../comment.model";

interface GardenerStoppedWorkingForCustomerCommentProps {
    comment: GardenerStoppedWorkingForCustomerCommentDocument;
}

export const GardenerStoppedWorkingForCustomerComment = (props: GardenerStoppedWorkingForCustomerCommentProps) => {
    const { comment } = props;

    const gardener = <Link to={`/gardeners/context/${comment.gardenerId}`}>{comment.gardenerName}</Link>;
    const customer = <Link to={`/customers/context/${comment.customerId}`}>{comment.customerName}</Link>;

    return (
        <Comment date={comment.creationDate.toDate().toISOString()} title="Kunde fjernet fra liste">
            <CommentBody>
                {gardener} har fjernet {customer} fra sin liste over tidligere kunder.
            </CommentBody>
        </Comment>
    );
};
